<div class="wrapper">
  <aside>
    <div class="side-nav">
    <h2>Mein Konto</h2>
    <p>{{(user$|async)?.email}}</p>
    </div>
    <ul class="side-nav">
      <li routerLink="orders">Meine Bestellungen</li>
      <li routerLink="subscriptions">Meine Abos</li>
    </ul>
    <div class="logout">
      <button (click)="clickLogout()">Logout</button>
    </div>
  </aside>
  <main>
    <router-outlet></router-outlet>

  </main>
</div>
